<script lang="ts">
	import type { TrafficInformationEvent } from './types';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import { trafficEvent as trafficEventType } from '$lib/i18n/computed/trafficEvent';
	import * as m from '$paraglide/messages';
	import { createEventDispatcher } from 'svelte';
	import { mapTrafficEventTypeToScheme } from './constants';

	export let trafficEvent: TrafficInformationEvent;

	$: trafficScheme = mapTrafficEventTypeToScheme[trafficEvent.type as keyof typeof mapTrafficEventTypeToScheme];

	const dispatch = createEventDispatcher<{ closeTrafficSummary: void }>();
</script>

<div class="flex flex-col gap-2 p-2 relative rd-2 shadow-subtle bg-neutral-weakest w-full">
	<div>
		<div class="text-md text-bold text-coloredneutral">
			{trafficEventType(trafficScheme)}
		</div>
		<div class="text-sm">
			{trafficEvent.description}
		</div>
	</div>
	<Button
		size="sm"
		text={m.modal__close()}
		onclick={() => dispatch('closeTrafficSummary')}
		class="w-fit"
	/>
</div>
